export const COLLECTIONS = Object.freeze({
  USER_PROFILES: 'userprofiles',
  BUSINESS_PROFILES: 'businessprofiles',
  FEED_POSTS: 'feedPost',
  FEED_EXPERIENCE: 'feedExperience',
  LISTINGS: 'forsale',
  INBOX: 'globalinbox',
  BUSINESS_EVENTS: 'tournaments',
  TEAMS: 'teamRegistrations',
  TOURNAMENTS: 'bucksTournaments',
  TOURNAMENT_ENTRIES: 'bucksTournamentEntries',
  TOURNAMENT_MATCHES: 'bucksTournamentMatches',
  TOURNAMENT_INVITES: 'bucksTournamentInvites',
  TOURNAMENT_ANNOUNCEMENTS: 'bucksTournamentAnnouncements',
  TOURNAMENT_USER_LINKS: 'bucksUserTournamentLinks',
  TOURNAMENT_INVITE_INBOXES: 'bucksTournamentInviteInboxes',
  TOURNAMENT_MANAGERS: 'bucksManagers',
  QUICK_RACES: 'quickRaces',
  RACE_PROFILES: 'userRaceProfiles',
  MAP_ADS: 'mapAds',
  WALLETS: 'wallet',
  PLAYER_STARS: 'playerStars',
  BLOCKED_USERS: 'blockedUsers',
  BLOCKED_BY: 'blockedBy',
  ACCOUNT_DELETION_REQUESTS: 'accountDeletionRequests',
  SUPPORT_REQUESTS: 'supportRequests',
  REPORTS: 'reports',
  FEED_REPORTS: 'feedReports',
  STORE_REPORTS: 'storeReports',
  AD_REPORTS: 'adReports',
});

export const TEAM_STATUS = Object.freeze({ ACTIVE: 'ACTIVE', DELETED: 'DELETED' });
export const TEAM_ROLE = Object.freeze({ OWNER: 'OWNER', ADMIN: 'ADMIN', MEMBER: 'MEMBER' });
export const TEAM_MEMBER_STATUS = Object.freeze({ ACTIVE: 'ACTIVE', LEFT: 'LEFT', BANNED: 'BANNED' });
export const TEAM_JOIN_POLICY = Object.freeze({ OPEN: 'OPEN', APPROVAL_REQUIRED: 'APPROVAL_REQUIRED' });

export const TOURNAMENT_STATUS = Object.freeze({
  DRAFT: 'DRAFT', CHECK_IN: 'CHECK_IN', OPEN: 'OPEN', LIVE: 'LIVE',
  COMPLETED: 'COMPLETED', CANCELLED: 'CANCELLED', DELETED: 'DELETED',
});
export const TOURNAMENT_ENTRY_STATUS = Object.freeze({
  PENDING: 'PENDING', JOINED: 'JOINED', INVITED: 'INVITED', WITHDRAWN: 'WITHDRAWN',
  NO_SHOW: 'NO_SHOW', ELIMINATED: 'ELIMINATED', ADVANCED: 'ADVANCED', CHAMPION: 'CHAMPION',
});
export const TOURNAMENT_MATCH_STATUS = Object.freeze({
  PENDING: 'PENDING', READY: 'READY', IN_PROGRESS: 'IN_PROGRESS', FINAL: 'FINAL', WALKOVER: 'WALKOVER',
});
export const RACE_STATUS = Object.freeze({ DRAFT: 'DRAFT', LIVE: 'LIVE', COMPLETED: 'COMPLETED', CANCELLED: 'CANCELLED' });

export const PROFILE_REQUIRED_FIELDS = Object.freeze([
  ['nickname', 'nickname'],
  ['bio', 'bio'],
  ['profileImageUrl', 'profile photo'],
]);

export const normalizeStatus = (value, fallback = '') => String(value || fallback).trim().toUpperCase();
export const activeStatus = (value) => !['DELETED', 'CANCELLED', 'WITHDRAWN', 'BANNED', 'LEFT'].includes(normalizeStatus(value));
export const text = (value) => String(value || '').trim();
export const list = (value) => (Array.isArray(value) ? value : []);
export const number = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};
export const timestampMillis = (value) => {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.seconds === 'number') return value.seconds * 1000;
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const evaluateProfileCompletion = (profile) => {
  const missingFields = PROFILE_REQUIRED_FIELDS
    .filter(([key]) => !text(profile?.[key]))
    .map(([, label]) => label);
  return { isComplete: missingFields.length === 0, missingFields };
};
